import { Icons } from 'pages/Workshop/Icons';
import styles from './styles.module.scss';
import { Spinner } from 'components';

export const SearchPlaceholderView = ({ isPending = false }) => {
  return (
    <div className={styles.searchPlaceholderView}>
      {isPending ? (
        <Spinner />
      ) : (
        <>
          <Icons variant={'searchPlaceholder'} />
          <div className={styles.searchPlaceholderText}>Start typing to search...</div>
        </>
      )}
    </div>
  );
};
